import React from 'react';
import { DragDropContext, Droppable } from '@hello-pangea/dnd';
import { v4 as uuid } from 'uuid';
import { DragDropListItem } from './DragDropListItem';
import { StyledDragDropList } from './DragDropList.styles';
const droppableId = uuid();
export const DragDropList = ({ items, onDragDropEnd }) => {
    return (React.createElement(DragDropContext, { onDragEnd: (result) => {
            const { destination, source } = result;
            if (!destination || destination.index === source.index) {
                return;
            }
            else {
                const newItemsOrder = Array.from(items);
                const movedItem = newItemsOrder.splice(source.index, 1);
                newItemsOrder.splice(destination.index, 0, movedItem[0]);
                onDragDropEnd(newItemsOrder);
            }
        } },
        React.createElement(Droppable, { droppableId: droppableId }, (provided) => (React.createElement(StyledDragDropList, Object.assign({ ref: provided.innerRef }, provided.droppableProps),
            items.map((item, index) => {
                return (React.createElement(DragDropListItem, { id: item.id, content: item.content, dragDisabled: item.dragDisabled, index: index, key: item.id }));
            }),
            provided.placeholder)))));
};
//# sourceMappingURL=DragDropList.js.map